import { render, staticRenderFns } from "./MenuPortfolios.vue?vue&type=template&id=60e2045c"
import script from "./MenuPortfolios.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuPortfolios.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MenuPortfolios.vue?vue&type=style&index=0&id=60e2045c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports